import { Customer_Invoices } from "data/endpoints";
import { useInjection } from "infrastructure/ioc/ioc.react";
import { IocTypes } from "infrastructure/ioc/ioc.types";
import React, { useEffect, useState } from "react";
import InvoiceSimplified from "../components/InvoiceSimplified";
import InvoiceSimplifiedHeader from "../components/InvoiceSimplifiedHeader";
import IExternalFilterData from "features/shared/components/dataFilter/IExternalFilterData";
import { DataGridId } from "features/shared/components/dataGrid/DataGridId";
import DataGrid from "features/shared/components/dataGrid/DataGrid";
import { loadDataFilterConfig, loadDataSortConfig } from "features/shared/helpers/modules";
import IInvoiceService from "features/invoices/services/IInvoiceService";
import { getQueryParams } from "features/shared/helpers/queryParams";
import { InvoiceType } from "features/invoices/enums/invoiceType";
import { useTranslation } from "react-i18next";

const invoicesDataFilterJson = loadDataFilterConfig("invoicesDataFilter");
const invoicesDataSortJson = loadDataSortConfig("invoicesDataSort");

const InvoicesSection = () => {
  // DI
  const invoiceService = useInjection<IInvoiceService>(IocTypes.InvoiceService);

  // translations
  const { i18n } = useTranslation();

  // state
  const [externalFilterData, setExternalFilterData] = useState<IExternalFilterData<any>[]>([]);

  // helpers
  const getAndSetExternalFilterData = async () => {
    let externalData = await invoiceService.getExternalFilterData(["Invoice"]);
    setExternalFilterData(externalData);
  };

  // Externí data pro filtr
  useEffect(() => {
    getAndSetExternalFilterData();
  }, []);

  // render
  return (
    <DataGrid 
      gridId={DataGridId.invoiceGrid}
      url={Customer_Invoices}
      filterJson={invoicesDataFilterJson}
      filterExternalData={externalFilterData}
      sortingJson={invoicesDataSortJson}
      renderItem={(item) => <InvoiceSimplified invoice={item} /> }
      renderHeader={() => <InvoiceSimplifiedHeader />}
      noFilterQueryParams={getQueryParams("InvoiceTypes", InvoiceType.Invoice)}
      externalDependencies={[i18n.language]}
    />
  );
};

export default InvoicesSection;
